var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import ProductView from "../presentation/products";
import axios from 'axios';
import CONSTS from "../consts";
const _ = require('lodash');
export default class Products extends React.Component {
    constructor(props) {
        super(props);
        this.allFacets = ['ConsumerType', 'Country', 'ConsumerCategory', 'Region', 'Vintage', 'ConsumerVarietal'];
        this.facetOptionMap = {
            ConsumerType: { inFilterOptions: false, location: 'categoryTypes', bodyValues: ['ConsumerType'], parseNumber: '' },
            ConsumerCategory: { inFilterOptions: false, location: 'ConsumerCategories', bodyValues: ['ConsumerCategory'], parseNumber: '' },
            Country: { inFilterOptions: true, location: 'Country', bodyValues: ['country'], parseNumber: '' },
            Vintage: { inFilterOptions: true, location: 'Vintage', bodyValues: ['vintage'], parseNumber: '' },
            Region: { inFilterOptions: true, location: 'Region', bodyValues: ['region'], parseNumber: '' },
            ConsumerVarietal: { inFilterOptions: true, location: 'Varietal', bodyValues: ['ConsumerVarietal'], parseNumber: '' },
        };
        this.searchCat = {
            'Wine': 'WINE',
            'Beer': 'BEER',
            'Liqueurs': 'LIQUEUR',
            'Spirits': 'SPIRITS',
            'Ciders & Coolers': 'CIDERS & COOLERS',
            'Other': 'NON-ALCOHOLIC'
        };
        this.orderByOptions = [
            { label: 'Relevancy', value: 'search.score()+desc' },
            { label: 'Product Name - A - Z', value: 'Name+asc' },
            { label: 'Product Name - Z - A', value: 'Name+desc' },
            { label: 'SKU # - 0 - 9', value: 'DisplaySKU+asc' },
            { label: 'SKU # - 9 - 0', value: 'DisplaySKU+desc' }
        ];
        this.cancelTokenSource = axios.CancelToken.source();
        this.getFacets = (facetsToGet) => __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products/ConnectMobile.Web.FilterAzurePost()`;
            let facetResults = [];
            for (let i = 0; i < facetsToGet.length; i++) {
                let facet = facetsToGet[i];
                let facetBody = this.getRequestBody(this.facetOptionMap[facet].bodyValues, [facet], true, false, 0, 0, "");
                let promise = axios.post(query, facetBody);
                facetResults.push(this.awaitFacet(facet, promise));
            }
            const results = yield Promise.all(facetResults);
            const newState = results.reduce((accum, result) => {
                let data = (result.data || []);
                data.sort();
                if (result.inFilterOptions) {
                    accum.FilterTypeOptions[result.location] = data;
                }
                else {
                    accum[result.location] = data;
                }
                return accum;
            }, { FilterTypeOptions: Object.assign({}, this.state.FilterTypeOptions) });
            this.setState(newState);
        });
        this.awaitFacet = (facet, promise) => __awaiter(this, void 0, void 0, function* () {
            const facetResult = yield promise;
            let facets = facetResult.data.Facets;
            return this.processFacet(facet, facets);
        });
        this.processFacet = (facet, facets) => {
            var data = facets[facet].filter((x) => { return x.trim().length > 0; });
            switch (this.facetOptionMap[facet].parseNumber) {
                case 'float':
                    data = data.map((x) => { return parseFloat(x).toFixed(1); });
                    break;
                case 'int':
                    data = data.map((x) => { return parseInt(x); });
                    break;
            }
            return Object.assign(Object.assign({}, this.facetOptionMap[facet]), { data });
        };
        this.getRequestBody = (toRemove, facets, includeFacets, includeCount, skip, top, orderBy) => {
            let consumerCategory = this.state.filterOptions.ConsumerCategory == "CIDERS & COOLERS" ?
                "COOLERS" :
                (this.state.filterOptions.ConsumerCategory);
            var body = {
                searchText: (this.state.filterOptions.searchText),
                country: (this.state.filterOptions.country),
                region: (this.state.filterOptions.region),
                ConsumerCategory: (consumerCategory),
                ConsumerType: (this.state.filterOptions.ConsumerType),
                ConsumerVarietal: (this.state.filterOptions.ConsumerVarietal),
                vintage: (this.state.filterOptions.vintage),
                colour: '',
                container: '',
                volumeMin: -1,
                volumeMax: -1,
                agentName: '',
                supplier: '',
                percAlcMin: -1,
                percAlcMax: -1,
                sweetMin: -1,
                sweetMax: -1,
                ibuMin: -1,
                ibuMax: -1,
                aroma: '',
                similar: '',
                AgentId: '',
                filter: this.state.filterOptions.filter,
                facets: includeFacets ? facets.join(',') : '',
                includeFacets,
                includeCount,
                orderBy,
                skip,
                top
            };
            for (let i = 0; i < toRemove.length; i++) {
                if (typeof body[toRemove[i]] === 'number') {
                    body[toRemove[i]] = -1;
                }
                else {
                    body[toRemove[i]] = '';
                }
            }
            return body;
        };
        this.getProducts = () => {
            if (this.state.loadingProducts) {
                return;
            }
            this.cancelTokenSource.cancel();
            this.setState({
                loadingProducts: true
            });
            const body = this.getRequestBody([], this.allFacets, true, true, this.state.filterOptions.skip, this.state.filterOptions.top, `SponsoredSKU+desc,${this.state.orderBy}`);
            const facestToGet = this.allFacets.reduce((accum, current) => {
                for (let i = 0; i < this.facetOptionMap[current].bodyValues.length; i++) {
                    let bodyValueText = this.facetOptionMap[current].bodyValues[i];
                    let value = body[bodyValueText];
                    if (value != null && value != '' && value != -1) {
                        accum.getIndividually.push(current);
                        return accum;
                    }
                }
                accum.getWithProducts.push(current);
                return accum;
            }, { getWithProducts: [], getIndividually: [] });
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products/ConnectMobile.Web.FilterAzurePost()`;
            this.cancelTokenSource = axios.CancelToken.source();
            axios.post(query, body, { cancelToken: this.cancelTokenSource.token })
                .then((response) => {
                let products = response.data.Products;
                let existingProducts = this.state.products.slice();
                let allProducts = existingProducts.concat(products);
                let skip = this.state.filterOptions.skip + 24;
                let newState = {
                    products: allProducts,
                    count: response.data.Count,
                    filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { skip }),
                    loading: false,
                };
                this.setState(newState, () => {
                    this.setState({ loadingProducts: false });
                });
                this.processProductFacets(response.data.Facets, facestToGet.getWithProducts);
                this.getFacets(facestToGet.getIndividually);
            });
        };
        this.processProductFacets = (facetData, facets) => {
            const newState = facets.map(f => this.processFacet(f, facetData)).reduce((accum, result) => {
                let data = (result.data || []);
                data.sort();
                if (result.inFilterOptions) {
                    accum.FilterTypeOptions[result.location] = data;
                }
                else {
                    accum[result.location] = data;
                }
                return accum;
            }, { FilterTypeOptions: Object.assign({}, this.state.FilterTypeOptions) });
            this.setState(newState);
        };
        this.changeTypes = (newType) => {
            this.setState({
                filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { ConsumerType: newType, skip: 0, top: 24, country: '', region: '', vintage: '', ConsumerVarietal: '' }),
                products: [],
                count: 0,
                FilterTypeOptions: {
                    Country: [],
                    Vintage: [],
                    Region: [],
                    Varietal: []
                }
            }, () => {
                this.updateRoute();
                this.getProducts();
            });
        };
        this.changeCategory = (newCategory) => {
            this.setState({
                filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { ConsumerCategory: newCategory, skip: 0, top: 24, country: '', region: '', vintage: '', ConsumerVarietal: '' }),
                products: [],
                count: 0,
                FilterTypeOptions: {
                    Country: [],
                    Vintage: [],
                    Region: [],
                    Varietal: []
                }
            }, () => {
                this.updateRoute();
                this.getProducts();
            });
        };
        this.updateMobileToggle = () => {
            this.setState({ toggleMobile: !this.state.toggleMobile });
        };
        this.updateRoute = () => {
            let route = '?';
            if (this.state.filterOptions.ConsumerType) {
                route += `liqType=${this.odataEncode(this.state.filterOptions.ConsumerType)}`;
            }
            if (this.state.filterOptions.country) {
                route += `&country=${this.odataEncode(this.state.filterOptions.country)}`;
            }
            if (this.state.filterOptions.region) {
                route += `&region=${this.odataEncode(this.state.filterOptions.region)}`;
            }
            if (this.state.filterOptions.vintage) {
                route += `&vintage=${this.odataEncode(this.state.filterOptions.vintage)}`;
            }
            if (this.state.filterOptions.ConsumerVarietal) {
                route += `&varietal=${this.odataEncode(this.state.filterOptions.ConsumerVarietal)}`;
            }
            route = route == '?' ? window.location.href.split('?')[0] : route;
            history.pushState({}, "Products - Liquor Connect", route.replace("?&", "?"));
        };
        this.updateSubFilter = (newattr, TypeOptions) => {
            let currentFilter = this.state.filterOptions[TypeOptions]
                .split(',')
                .filter((x) => { return x.length > 0; });
            if (currentFilter.includes(newattr)) {
                currentFilter.splice(currentFilter.indexOf(newattr), 1);
            }
            else {
                currentFilter.push(newattr);
            }
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions[TypeOptions] = currentFilter.join(',');
            this.setState({
                filterOptions,
                products: [],
                count: 0
            }, () => {
                this.updateRoute();
                this.getProducts();
            });
        };
        this.updateOrderBy = (orderBy) => {
            this.setState({
                filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 }),
                products: [],
                count: 0,
                orderBy
            }, this.getProducts);
        };
        this.clearFilter = () => {
            this.setState({
                filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24, country: '', region: '', vintage: '', ConsumerVarietal: '', ConsumerCategory: this.searchCat[this.props.route] || "" }),
                products: [],
                count: 0,
            }, () => {
                this.updateRoute();
                this.getProducts();
            });
        };
        this.state = {
            products: [],
            categoryTypes: [],
            count: 0,
            filterOptions: {
                skip: 0,
                top: 24,
                searchText: '',
                country: this.props.country || "",
                region: this.props.region || "",
                ConsumerCategory: this.searchCat[this.props.route] || "",
                ConsumerType: this.props.liqtype || "",
                ConsumerVarietal: this.props.varietal || "",
                vintage: this.props.vintage || "",
                filter: this.props.filter || ""
            },
            orderBy: 'search.score()+desc',
            ConsumerCategories: [],
            FilterTypeOptions: {
                Country: [],
                Vintage: [],
                Region: [],
                Varietal: [],
            },
            loading: true,
            loadingProducts: false,
            toggleMobile: false
        };
    }
    odataEncode(text) {
        return encodeURIComponent(text).replace(/'/g, "''").replace(/&/g, " ");
    }
    filterToAzure(text) {
        let newText = text
            .split(',')
            .map((item) => { return `"${item}"`; })
            .join('||');
        return text.length > 0 ? encodeURIComponent(newText) : "";
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            //this.getProducts();
        });
    }
    render() {
        return (React.createElement(ProductView, { categoryTypes: this.props.route === 'Alberta Made' ? this.state.ConsumerCategories : this.state.categoryTypes, changeTypes: this.props.route === 'Alberta Made' ? this.changeCategory : this.changeTypes, typeSelected: this.props.route === 'Alberta Made' ? this.state.filterOptions.ConsumerCategory : this.state.filterOptions.ConsumerType, country: this.state.filterOptions.country, region: this.state.filterOptions.region, vintage: this.state.filterOptions.vintage, varietal: this.state.filterOptions.ConsumerVarietal, route: this.props.route, products: this.state.products, getProducts: this.getProducts, toggleMobile: this.state.toggleMobile, updateMobileToggle: this.updateMobileToggle, count: this.state.count, clearFilter: this.clearFilter, FilterTypeOptions: this.state.FilterTypeOptions, updateSubFilter: this.updateSubFilter, updateOrderBy: this.updateOrderBy, currentOrderBy: this.state.orderBy, orderByOptions: this.orderByOptions }));
    }
}
;
//# sourceMappingURL=products.js.map